/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_UpdateInputs */

const en_cancel_update = /** @type {(inputs: Cancel_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Update`)
};

const fr_cancel_update = /** @type {(inputs: Cancel_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler la mise à jour`)
};

const de_cancel_update = /** @type {(inputs: Cancel_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisierung abbrechen`)
};

const it_cancel_update = /** @type {(inputs: Cancel_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla aggiornamento`)
};

const ru_cancel_update = /** @type {(inputs: Cancel_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отменить обновление`)
};

const es_cancel_update = /** @type {(inputs: Cancel_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar actualización`)
};

const zh_cn2_cancel_update = /** @type {(inputs: Cancel_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消更新`)
};

const ja_cancel_update = /** @type {(inputs: Cancel_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新をキャンセル`)
};

const hi_cancel_update = /** @type {(inputs: Cancel_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपडेट रद्द करें`)
};

const pt_pt2_cancel_update = /** @type {(inputs: Cancel_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar atualização`)
};

/**
* | output |
* | --- |
* | "Cancel Update" |
*
* @param {Cancel_UpdateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cancel_update = /** @type {((inputs?: Cancel_UpdateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_UpdateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_cancel_update(inputs)
	if (locale === "de") return de_cancel_update(inputs)
	if (locale === "it") return it_cancel_update(inputs)
	if (locale === "ru") return ru_cancel_update(inputs)
	if (locale === "es") return es_cancel_update(inputs)
	if (locale === "zh-CN") return zh_cn2_cancel_update(inputs)
	if (locale === "ja") return ja_cancel_update(inputs)
	if (locale === "hi") return hi_cancel_update(inputs)
	if (locale === "pt-PT") return pt_pt2_cancel_update(inputs)
	return en_cancel_update(inputs)
});